import React, { Component } from 'react'
import Style from './AddOrganization.module.css'
import { inviteAdmin, setError, setCurrentCustomer, unSetStatusCode } from '../store/entities/customers'
import { connect } from 'react-redux'
import ConfirmPopup from "./common/popover/confirmPopup";
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper'
import BackIcon from '../assets/backButton.svg'
import { validateAlphaNumerics, validateEmail } from '../utilities/vaildations' 

const addAdminConfig = {
    PixmAdmin : {
        title: 'Add Pixm Admin',
        returnButtonText: 'Return to Pixm Admin Management',
        submitButtonText: 'Invite Pixm Admin',
        urlPath: '/advanced-settings/add-pixm-admin',
        returnPath: '/advanced-settings',
        returnSelectedTab: 'Pixm Admin Management',
        role: 'PixmAdmin'
    },
    TenantAdmin: {
        title: 'Add MSP Admin',
        returnButtonText: 'Return to Admin Management',
        submitButtonText: 'Invite Admin',
        urlPath: '/tenant-admin/add-admin',
        returnPath: '/tenant-admin',
        returnSelectedTab: 'Admin Management',
        role: 'TenantAdmin'
    },
    CustomerAdmin : {
        title: 'Add Customer Admin',
        returnButtonText: 'Return to Admin Management',
        submitButtonText: 'Invite Customer Admin',
        urlPath: '/customers/:id/settings/add-admin',
        returnPath: '/customers/:id/settings',
        returnSelectedTab: 'Admin Management',
        role: 'CustomerAdmin'
    },
    default: {
        title: 'Add Admin',
        returnButtonText: 'Return to Admin Management',
        submitButtonText: 'Invite Admin',
        urlPath: '/customers/:id/settings/add-admin',
        returnPath: '/customers/:id/settings',
        returnSelectedTab: 'Admin Management',
        role: 'CustomerAdmin'
    }

}

class AddAdmin extends Component {

    constructor() {
        super();
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            setCustomerOnce: true,
            adminType: ''
        };
    }

    componentDidMount() {
        let adminType = this.getAdminType();
        this.setState({ adminType: adminType || null });
    }

    componentDidUpdate(prevProps) {
        let adminType = this.getAdminType();
        if (prevProps !== this.props && this.state.setCustomerOnce && adminType === 'CustomerAdmin') {
          this.setState({
            setCustomerOnce: false
          })
          
          let filtredElement = this.props.orgList.filter((ele) => ele.id === this.props.match.params.id)
    
          if (filtredElement[0].id !== this.props.selectedCustomer.id) {
            this.props.setCurrentCustomer(filtredElement[0]);
          }
        }
      }

    handleChange = (event) => {
        const value = event.target.value
        this.setState({
            [event.target.name]: value
        })
    }

    returnToAdminManagement = () => {
        let { adminType } = this.state

        if(adminType === 'PixmAdmin' || adminType === 'TenantAdmin') {
            this.props.history.push({ pathname: addAdminConfig[adminType].returnPath, state: { tab: addAdminConfig[adminType].returnSelectedTab } })
        }
        else {
            this.props.history.push({ pathname: `/customers/${this.props.selectedCustomer.id}/settings`, state: { tab: 'Admin Management' } })
        }
    }

    handleSubmit = () => {

        let error = ''

        if(this.state.email === '') {
            let error = "Email is required"
            this.props.setError(error)
        } else if (!validateEmail(this.state.email) || this.state.email.length > 200) {
            error = "Please enter a proper email id"
            this.props.setError(error)
        }

        if(this.state.lastName === '') {
            error = "Last name is required"
            this.props.setError(error)
        } else if (!validateAlphaNumerics(this.state.lastName) || this.state.firstName.length > 50) {
            error = "Last name should only be alphanumeric and not more than 50 characters"
            this.props.setError(error)
        }

        if(this.state.firstName === '') {
            error = "First name is required"
            this.props.setError(error)
        } else if (!validateAlphaNumerics(this.state.firstName) || this.state.firstName.length > 50) {
            error = "First name should only be alphanumeric and not more than 50 characters"
            this.props.setError(error)
        }

        if(error === '') {
            let body = {
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "email": this.state.email,
                "role": this.state.adminType
            }
            if (body.role === "CustomerAdmin")
                body.customerId = this.props.selectedCustomer.id;

            this.props.inviteAdmin(body)
        }
        
    }

    getAdminType = () => {
        let adminType = Object.keys(addAdminConfig).find(key => addAdminConfig[key].urlPath === this.props.match.path);
        return adminType || "CustomerAdmin";
    }

    handleConfirmClose = () => {
        if(this.props.statusCode === 200){
            this.returnToAdminManagement();
        }
        this.props.unSetStatusCode();
    }

    render() {
        return (
            <div className={'px-5 mt-4'}>
                <div className={`${Style.headerBg} px-5 d-flex align-items-center justify-content-between`}>
                    <div onClick={this.returnToAdminManagement} style={{ cursor: 'pointer' }}>
                        <img style={{ height: '1.5vw' }} src={BackIcon} alt={'back-icon'} />
                        {addAdminConfig[this.state.adminType]?.returnButtonText || addAdminConfig.default.returnButtonText}
                    </div>
                </div>
                <div className={`${Style.detailsContainer} w-50 mt-4 py-5 px-5`}>
                    {this.props.loading ? (
                    <LoaderWrapper loading={this.props.loading} isFlex={true} styles={{top: '15px', width: '100px'}} waitForData={false}></LoaderWrapper>
                    ) :
                    (
                    <>
                    <div className={`d-flex flex-column`}>
                        <input name='firstName' placeholder={'First Name'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />

                        <input name='lastName' placeholder={'Last Name'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />

                        <input name='email' placeholder={'Email'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />
                    </div>
                    <div className={'mt-4'}>
                        <button onClick={this.handleSubmit} className={`${Style.submitButton} px-4 focus-none`}>{addAdminConfig[this.state.adminType]?.submitButtonText || addAdminConfig.default.submitButtonText}</button>
                        <button onClick={this.returnToAdminManagement} className={`${Style.cancelButton} px-4 ml-2 focus-none`}>Cancel</button>
                    </div>
                    </>)}
                </div>
                    {this.props.statusCode && (
                    <ConfirmPopup
                        details={{
                        icon: '',
                        type: this.props.statusCode === 200 ? 'success':'error',
                        title: this.props.statusCode === 200 ? 'Admin Invited Successfully':'Admin could not be invited.',
                        description: this.props.userMsg,
                        buttons: 'O',
                        }}
                        onCloseClick={this.handleConfirmClose} />
                    )}            
                </div>
        )
    }
}

const mapStateToProps = (state) => ({
    userFlag: state.entities.customers.userListFlag,
    userRole: state.entities.user.roles,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
    orgList: state.entities.customers.list,
    selectedCustomer: state.entities.customers.selected,
    loading: state.entities.customers.loading
})

const mapDispatchToProps = (dispatch) => ({
    inviteAdmin: (body) => dispatch(inviteAdmin(body)),
    setError: (error) => dispatch(setError(error)),
    setCurrentCustomer: (customerId) => dispatch(setCurrentCustomer(customerId)),
    unSetStatusCode: () => dispatch(unSetStatusCode()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddAdmin)